export const EMPTY_NICHES_MESSAGE = "You must follow a niche to add content to it.";
export const EMPTY_LIST_MESSAGE = "No matches found? Try editing your tags or creating a Niche.";
